import { render, staticRenderFns } from "./ResourceFrame.vue?vue&type=template&id=7a31680f&scoped=true&"
import script from "./ResourceFrame.vue?vue&type=script&lang=js&"
export * from "./ResourceFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31680f",
  null
  
)

export default component.exports